import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Newsletter = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email || !/^[^@]+@[^@]+\.[^@]+$/.test(email)) {
            toast.error("Please enter a valid email.");
            return;
        }
        try {
            setLoading(true);
            const res = await axios.post(`${API}/newsletter`, { email });
            toast.success(res.data?.message || "Subscribed.");
            setEmail("");
        } catch (err) {
            toast.error(
                err?.response?.data?.detail || "Could not subscribe. Try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <section
            id="newsletter"
            data-testid="newsletter-section"
            className="relative bg-tip-paper text-tip-black py-24 md:py-36"
        >
            <div className="tip-container">
                <div className="grid lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-7">
                        <div className="eyebrow text-black/60 mb-6">
                            06 — Newsletter
                        </div>
                        <motion.h2
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.8 }}
                            className="font-display font-black text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-[-0.03em]"
                        >
                            Stay part of the{" "}
                            <span className="italic">conversation.</span>
                        </motion.h2>
                        <p className="mt-6 max-w-xl text-black/70 text-base md:text-lg">
                            One email a month. New episodes, behind-the-scenes,
                            and the questions we&apos;re asking next. No spam.
                            Ever.
                        </p>
                    </div>

                    <div className="lg:col-span-5">
                        <form
                            onSubmit={submit}
                            data-testid="newsletter-form"
                            className="flex flex-col sm:flex-row border border-tip-black bg-tip-white"
                        >
                            <input
                                data-testid="newsletter-email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@india.com"
                                className="flex-1 px-5 py-5 bg-transparent outline-none placeholder:text-black/40 text-base"
                            />
                            <button
                                type="submit"
                                disabled={loading}
                                data-testid="newsletter-submit"
                                className="btn-block btn-block-dark rounded-none border-0 px-7 disabled:opacity-60"
                            >
                                {loading ? "..." : "Subscribe"}
                                <ArrowRight size={16} />
                            </button>
                        </form>
                        <p className="mt-3 text-xs text-black/50 tracking-wide">
                            By subscribing you agree to our editorial values:
                            free speech, respectful disagreement, non-partisan.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
